import React from 'react';
import '../Style/VersionItem.css';
import Accuracy from './Accuracy.view';
import utilService from '../../../services/utilService';

const VersionItem = ({versionNumber, date = '', accuracy = '', insights = [], feature = '', isShowToolTip = true, id = null, onClick = null, isCanOpenEvalImages = false}) => (
    <div className='version-item-container'>
        {versionNumber && <p>{`v${versionNumber} ${date ? ' - ' : ''}`}</p>}
        {date && <p className='version-item-date'>{utilService.formatDate(date)}</p>}
        {accuracy && <Accuracy isShowToolTip={isShowToolTip} accuracy={accuracy} insights={insights} versionNumber={versionNumber}
            feature={feature} id={id} onClick={onClick} isCanOpenEvalImages={isCanOpenEvalImages}/>}
    </div>
);

export default VersionItem;
